import React from 'react';

function BasicSectionCard({ id, title, children }) {
  return (
    <section id={id} className="rounded-none p-4 sm:p-5" style={{ backgroundColor: 'var(--card)' }}>
      <div className="space-y-3">
        <h2 className="text-base font-semibold text-[var(--primary)]">{title}</h2>
        <div className="space-y-3">
          {children}
        </div>
      </div>
    </section>
  );
}

export default BasicSectionCard;
